




import { UserModule } from '@/store/modules/user';
import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { Component, Prop, Vue } from 'vue-property-decorator';
import AddEditList from '@/components/AddEditList.vue';

@Component({components: {AddEditList}})
export default class CreateList extends Vue {
  public list: ListModel = ListModel.empty();
}
